import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';

@Component({
  selector: 'app-error-logout-modal',
  templateUrl: './error-logout-modal.component.html',
  styleUrls: ['./error-logout-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorLogoutModalComponent {
  readonly showModal = input<boolean>(false);
  readonly handleLogout = output<void>();

  onSignOut() {
    this.handleLogout.emit();
  }
}
